<template>
  <div class="mx-auto w-full h-screen overflow-y-scroll">
    <div class="w-full h-full">
      <slot />
    </div>
  </div>
</template>
